module.exports = "/public/images/9e50bee7af3139f2e22977ba8982086d.svg";